import { ReactElement, ReactNode } from 'react'
import { Location, RouteType } from '../types'
import { RouteContext } from './contexts'

export function Route(_: RouteType) {
  return null
}

export function RenderedRoute({
  outlet,
  location,
  locationSoFar,
  completeLocationSoFar,
  children,
}: {
  outlet: ReactElement
  location: Location
  locationSoFar: Location
  completeLocationSoFar: Location
  children?: ReactNode
}) {
  return (
    <RouteContext.Provider
      value={{ outlet, location, locationSoFar, completeLocationSoFar }}
    >
      {children}
    </RouteContext.Provider>
  )
}
